import { Link } from "react-router-dom";
import { Home, ArrowUpRight } from "lucide-react";
import HeartbeatLine from "@/components/HeartbeatLine";

export default function NotFound() {
  return (
    <div className="min-h-[80vh] grid place-items-center bg-[color:var(--paper-2)] relative overflow-hidden" data-testid="page-404">
      <div className="absolute inset-0 bg-grid-light opacity-40" />
      <div className="relative text-center px-6 max-w-lg">
        <div className="text-[8rem] font-bold leading-none text-slate-200" style={{ fontFamily: "'Outfit',sans-serif" }}>404</div>
        <h1 className="text-3xl md:text-4xl font-bold mt-2" style={{ fontFamily: "'Outfit',sans-serif" }}>
          Looks like this <span className="text-[color:var(--brand)]">pulse</span> is offline.
        </h1>
        <p className="mt-3 text-slate-600">The page you&apos;re looking for moved, was renamed, or never existed.</p>
        <div className="my-6">
          <HeartbeatLine height={50} />
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary"><Home className="w-4 h-4" /> Back to Home</Link>
          {/* <Link to="/request-demo" className="btn-ghost">Request Demo <ArrowUpRight className="w-4 h-4" /></Link> */}
        </div>
      </div>
    </div>
  );
}
